import styled from "@emotion/styled";
import { darken } from "@material-ui/core/styles/colorManipulator";
import BaseButton from "./BaseButton";

export default styled("button")`
    ${BaseButton};
    background: ${(props) => props.theme.palette.secondary.main};
    color: ${(props) => props.theme.palette.cta.text};

    :hover {
        background: ${(props) => darken(props.theme.palette.secondary.main, 0.08)};
        transition: all 0.3s ease;
    }

    :active {
        background: ${(props) => darken(props.theme.palette.secondary.main, 0.25)};
    }

    :disabled {
        background: ${(props) => props.theme.palette.grey[20]};
        cursor: default;
    }
`;
